import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VStepper,
    {
      attrs: { "alt-labels": "" },
      model: {
        value: _vm.e1,
        callback: function ($$v) {
          _vm.e1 = $$v
        },
        expression: "e1",
      },
    },
    [
      _c(
        VStepperHeader,
        [
          _vm._l(_vm.steps, function (step, i) {
            return [
              _c(
                VStepperStep,
                {
                  key: "step-" + i,
                  attrs: {
                    complete: _vm.e1 > i + 1,
                    step: i + 1,
                    "edit-icon": "done",
                    editable: "",
                  },
                },
                [
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(" " + _vm._s(step) + " "),
                  ]),
                ]
              ),
              i + 1 < _vm.stepsNumber
                ? _c(VDivider, { key: "divider-" + i })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c(
        VStepperItems,
        _vm._l(_vm.stepsNumber, function (contentNumber) {
          return _c(
            VStepperContent,
            { key: "content-" + contentNumber, attrs: { step: contentNumber } },
            [
              _c(
                VCard,
                {
                  staticClass:
                    "d-flex flex-column justify-center align-center mb-8 tamanhoModal",
                  attrs: { flat: "" },
                },
                _vm._l(
                  _vm.tutorialContent[contentNumber - 1].children,
                  function (content, i) {
                    return _c("v-node", {
                      key: `children-${contentNumber}-${i}`,
                      class: {
                        "text-center text-h4 font-weight-medium pa-4 primary--text":
                          content.tag == "h2",
                        "mx-6 pa-4 text-center font-weight-medium text-lg-h6":
                          content.tag == "p",
                      },
                      attrs: { vnode: content },
                    })
                  }
                ),
                1
              ),
              _c("div", { staticClass: "d-flex justify-space-between pa-3" }, [
                _c(
                  "div",
                  [
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  contentNumber < _vm.stepsNumber
                                    ? _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            attrs: {
                                              color: "error",
                                              text: "",
                                              "x-large": "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.close()
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              attrs: {
                                                dark: "",
                                                "x-large": "",
                                              },
                                            },
                                            [_vm._v(" close ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Clique para fechar")])]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  contentNumber > 1
                                    ? _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              color: "primary",
                                              text: "",
                                              "x-large": "",
                                            },
                                            on: { click: _vm.prev },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              attrs: {
                                                dark: "",
                                                "x-large": "",
                                              },
                                            },
                                            [_vm._v(" chevron_left ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Clique para voltar")])]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  contentNumber < _vm.stepsNumber
                                    ? _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            attrs: {
                                              color: "primary",
                                              text: "",
                                              "x-large": "",
                                            },
                                            on: { click: _vm.next },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              attrs: {
                                                dark: "",
                                                "x-large": "",
                                              },
                                            },
                                            [_vm._v(" chevron_right ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Clique para continuar")])]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  contentNumber == _vm.stepsNumber
                                    ? _c(
                                        VBtn,
                                        _vm._g(
                                          {
                                            attrs: {
                                              color: "success",
                                              text: "",
                                              "x-large": "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.close()
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            {
                                              attrs: {
                                                dark: "",
                                                "x-large": "",
                                              },
                                            },
                                            [_vm._v(" check ")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Clique para finalizar")])]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }